import type { ActivityRegion } from '../interfaces'

export const getRegionDataArray = (regionData: ActivityRegion[]) => {
    return regionData.map((region: ActivityRegion) => {
        return {
            regionId: region.regionId,
            locationType: 'region',
            clusters: region.clusters.map((cluster) => {
                return {
                    clusterId: cluster.clusterId,
                    locationType: 'cluster',
                    stores: cluster.stores.map((store) => {
                        return {
                            storeId: store.storeId,
                            locationType: 'store'
                        }
                    })
                }
            })
        }
    })
}
